import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../Button';
import Popup from '../../../Popup';

interface Props extends React.ComponentPropsWithRef<typeof Popup> {
  isLoading?: boolean;
  onSubmit: () => void;
}

const DeleteCommentButtonPopup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    isLoading = false,
    onSubmit,
    ...rest
  } = props;

  const { t } = useTranslation();

  return (
    <Popup
      ref={ref}
      title={t('pages.forum.delete_comment.title')}
      closeButtonText={t('buttons.close')}
      cta={(
        <Button buttonState={isLoading && 'disabled'} onClick={onSubmit}>
          {t('pages.forum.delete_comment.submit')}
        </Button>
      )}
      {...rest}
    />
  );
});

export default DeleteCommentButtonPopup;
